var exports = {
  "X": "SavedMessagesContent.module__scroller___dzk1by",
  "W": "SavedMessagesContent.module__messageCard___dzk1by",
};

module.exports = exports;
